<template>
  <h1 v-if="!hidden" style="color: red; margin-top: 70px;">
    Working in non-production environment.
    <v-btn
      icon
      color="pink"
      @click="hideAlert"
    >
      x
    </v-btn>
  </h1>
</template>

<script>
export default {
  name: "mediligo-production-check",
  props: [],
  data() {
    return {
      hidden: false
    }
  },
  methods: {
    hideAlert() {
      this.hidden = true
    }
  }
}
</script>

<style scoped>

</style>
